var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ds-datagrid-content-wrap card-mode" },
    [
      _c("dsf-platform-card-box", {
        ref: "cardBox",
        attrs: {
          data: _vm.data,
          "column-number": _vm.layoutInfo.columnNumber,
          "column-width": _vm.layoutInfo.columnWidth,
          "margin-top": _vm.layoutInfo.marginTop,
          "checkbox-style": _vm.layoutInfo.checkboxStyle,
          "checkbox-size": _vm.layoutInfo.checkboxSize,
          "checkbox-position": _vm.layoutInfo.checkboxPosition,
          checkbox: _vm.checkboxColumn.show,
          "max-check-num": _vm.isSingleChecked ? 1 : 0,
          selectable: _vm.selectable,
        },
        on: {
          select: _vm.select,
          "select-all": _vm.selectAll,
          "on-contextmenu": _vm.onContextmenu,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "default",
              fn: function (scope) {
                return [_vm._t("default", null, null, scope)]
              },
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }